import { useCallback } from 'react';
import { MESSAGE_TYPES } from '../../shared/constants';
import { notifyParent } from './notifyParent';

export default () => {
	const scrollTop = useCallback(() => notifyParent({ message: MESSAGE_TYPES.ON_SCROLL_TOP }));

	return scrollTop;
};
